(() => {
  function initCarousels(root = document) {
    root.querySelectorAll('.o-product-discovery__section').forEach((section) => {
      if (section.dataset.oCarouselReady) return;
      const track = section.querySelector('[data-o-carousel-track]');
      const controls = section.querySelector('[data-o-carousel-controls]');
      if (!track || !controls) return;
      section.dataset.oCarouselReady = 'true';
      const cards = Array.from(track.querySelectorAll('.o-card'));
      const previous = controls.querySelector('[data-o-carousel-prev]');
      const next = controls.querySelector('[data-o-carousel-next]');
      const count = controls.querySelector('[data-o-carousel-count]');
      const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
      const update = () => {
        const overflow = cards.length > 1 && track.scrollWidth > track.clientWidth + 3;
        controls.hidden = !overflow;
        if (!overflow) return;
        const width = Math.max(step(), 1);
        const first = Math.min(cards.length, Math.round(track.scrollLeft / width) + 1);
        const visible = Math.max(1, Math.ceil((track.clientWidth - 2) / width));
        const last = Math.min(cards.length, first + visible - 1);
        count.textContent = `${first}–${last} of ${cards.length}`;
        previous.disabled = track.scrollLeft < 3;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
      };
      const move = (direction) => track.scrollBy({ left: direction * step(), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initCarousels(), { once: true });
  else initCarousels();
  document.addEventListener('shopify:section:load', (event) => initCarousels(event.target));
})();
